import AccountAccessConfirm from "./AccountAccessConfirm";

export default AccountAccessConfirm;
